export default __webpack_public_path__ + "static/media/SWR.3bc9fad5.svg";